export const Marquee = ({ items = [], className = "" }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className={`marquee relative overflow-hidden border-y border-white/10 bg-obsidian py-6 sm:py-8 ${className}`}>
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl font-bold uppercase tracking-[-0.02em] text-white/90 sm:text-5xl lg:text-6xl whitespace-nowrap px-6 sm:px-10">{item}</span>
            <span className="h-2.5 w-2.5 rotate-45 bg-crimson sm:h-3 sm:w-3" />
          </span>
        ))}
      </div>
    </div>
  );
};
